import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { AppContextProvider } from "./context/AppContext";
import React, { useContext, Suspense } from "react";
import SignIn from "./pages/SignIn";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Error from "./pages/Error";
import ResetPassword from "./pages/ResetPassword";
import ReportManager from "./pages/ReportManager";
import LabHistoryManager from "./pages/LabHistory";
import Profile from "./pages/Profile";
import Dashboard from "./pages/Dashboard";
import Main from "./components/layout/Main";
import RewardPoint from "./pages/RewardPoint";
import RewardPointCategory from "./pages/RewardPointCategory";
import RedemptionsSettings from "./pages/RedemptionsSettings";
import Orders from "./pages/Orders";
import OrderDetails from "./pages/OrderDetails";
import Shipments from "./pages/Shipment/Shipments";
import ShipmentDetails from "./pages/Shipment/ShipmentDetails";
import InvoicePage from "./pages/Invoices";
import InvoiceDetails from "./pages/Invoices/viewpage";
import RefundIndex from "./pages/Refunds";
import RefundDetails from "./pages/Refunds/viewpage";
import TransactionIndex from "./pages/Transaction";
import ProductsIndex from "./pages/Products";
import ProductAddEdit from "./pages/Products/add";
import InvoiceAddEdit from "./pages/Invoices/add";
import CustomersIndex from "./pages/Customer";
import ReportingSales from "./pages/Reporting/Sales";
import SettingsUsers from "./pages/Settings/Users";
import SettingsRoles from "./pages/Settings/Roles";
import SettingsImports from "./pages/Settings/Imports";
import CategoryIndex from "./pages/Category";
import ProductView from "./pages/Products/view";
import ProductDetail from "./pages/Products/edit";
import AttributesIndex from "./pages/Attributes";
import AdminEmail from "./pages/Settings/AdminEmail";
import WebsiteSetting from "./pages/Settings/WebsiteSetting";

window.Buffer = window.Buffer || require("buffer").Buffer;

function App() {
  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const privateRoutes = (isLoggedIn) => {
  return (
    <Route
      path="/"
      element={
        // <PrivateRoute>
        <Layout />
        // </PrivateRoute>
      }
    >
      <Route index element={<Navigate to="/dashboard" replace />} />
      <Route exact path="/dashboard" element={<Dashboard />} />
      <Route exact path="/report-manager" element={<ReportManager />} />
      <Route exact path="/upload-history" element={<LabHistoryManager />} />
      <Route exact path="/profile" element={<Profile />} />
      <Route exact path="/reward-point" element={<RewardPoint />} />
      <Route exact path="/reward-point-category" element={<RewardPointCategory />} />
      <Route exact path="/redemptions-settings" element={<RedemptionsSettings />} />
      <Route exact path="/sales/orders" element={<Orders />} />
      <Route exact path="/sales/orders/:id" element={<OrderDetails />} />
      <Route exact path="/sales/shipments" element={<Shipments />} />
      <Route exact path="/sales/shipments/:id" element={<ShipmentDetails />} />
      <Route exact path="/sales/invoices" element={<InvoicePage />} />
      <Route exact path="/sales/invoices/add" element={<InvoiceAddEdit />} />
      <Route exact path="/sales/invoices/:id" element={<InvoiceDetails />} />
      <Route exact path="/sales/refunds" element={<RefundIndex />} />
      <Route exact path="/sales/refunds/:id" element={<RefundDetails />} />
      <Route exact path="/sales/transactions" element={<TransactionIndex />} />
      <Route exact path="/catalog/products" element={<ProductsIndex />} />
      <Route exact path="/catalog/products/add" element={<ProductAddEdit />} />
      <Route exact path="/catalog/products/:id" element={<ProductView />} />
      <Route exact path="/catalog/products/edit/:id" element={<ProductDetail />} />
      <Route exact path="/customers" element={<CustomersIndex />} />
      <Route exact path="/reporting/sales" element={<ReportingSales />} />
      <Route exact path="/settings/users" element={<SettingsUsers />} />
      <Route exact path="/settings/roles" element={<SettingsRoles />} />
      <Route exact path="/settings/data-transfer" element={<SettingsImports />} />
      <Route exact path="/catalog/categories" element={<CategoryIndex />} />
      <Route exact path="/catalog/attributes" element={<AttributesIndex />} />
      <Route exact path="/settings/admin-email" element={<AdminEmail />} />
      <Route exact path="/settings/website-settings" element={<WebsiteSetting />} />
    </Route>
  );
};

const publicRoutes = (isLoggedIn) => {
  return (
    <>
      <Route path="/login" element={<SignIn />} />
      <Route path="/" element={<SignIn />} />
      <Route path="/admin/reset-password/:id" element={<ResetPassword />} />
      <Route element={<Layout />}>
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/reward-point" element={<RewardPoint />} />
        <Route exact path="/reward-point-category" element={<RewardPointCategory />} />
        <Route exact path="/redemptions-settings" element={<RedemptionsSettings />} />
        <Route exact path="/sales/orders" element={<Orders />} />
        <Route exact path="/sales/orders/:id" element={<OrderDetails />} />
        <Route exact path="/sales/shipments" element={<Shipments />} />
        <Route exact path="/sales/shipments/:id" element={<ShipmentDetails />} />
        <Route exact path="/sales/invoices" element={<InvoicePage />} />
        <Route exact path="/sales/invoices/add" element={<InvoiceAddEdit />} />
        <Route exact path="/sales/invoices/:id" element={<InvoiceDetails />} />
        <Route exact path="/sales/refunds" element={<RefundIndex />} />
        <Route exact path="/sales/refunds/:id" element={<RefundDetails />} />
        <Route exact path="/sales/transactions" element={<TransactionIndex />} />
        <Route exact path="/catalog/products" element={<ProductsIndex />} />
        <Route exact path="/catalog/products/add" element={<ProductAddEdit />} />
        <Route exact path="/catalog/products/:id" element={<ProductAddEdit />} />
        
      <Route exact path="/catalog/products/:id" element={<ProductDetail />} />
        <Route exact path="/customers" element={<CustomersIndex />} />
        <Route exact path="/reporting/sales" element={<ReportingSales />} />
        <Route exact path="/settings/users" element={<SettingsUsers />} />
        <Route exact path="/settings/roles" element={<SettingsRoles />} />
        <Route exact path="/settings/data-transfer" element={<SettingsImports />} />
        {/* <Route exact path="/customer-groups" element={<CustomerGroupsIndex />} />
        <Route exact path="/customer-reviews" element={<CustomerReviewsIndex />} /> */}
      <Route exact path="/catalog/categories" element={<CategoryIndex />} />
      <Route exact path="/catalog/attributes" element={<AttributesIndex />} />
      <Route exact path="/settings/admin-email" element={<AdminEmail />} />
      <Route exact path="/settings/website-settings" element={<WebsiteSetting />} />

      </Route>
    </>
  );
};

const AppRoutes = () => {
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <Routes>
      {!isLoggedIn && publicRoutes()}
      {isLoggedIn && privateRoutes()}
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <Main>
      <Outlet />
    </Main>
  );
};

export default App;
